<template>
    <cmpCreate :name="name"
               :subPath="subPath"
               :pkColumn="pkColumn"
               :fields="fields"
               :parent="parent"
               :header="header"
               :goBackAfterCreate="goBackAfterCreate"
               v-model="formData"
               ref="cmpCreate">
    </cmpCreate>
</template>

<script>
    import cmpCreate from "@/components/common/cmpCreate";
    import i18n from '@/i18n';
    import ApiService from '@/ApiService';

    export default {
        components: {
            cmpCreate
        },
        data() {
            return {
                name: "Tenant",
                subPath: "Course",
                pkColumn: "CourseId",
                parent: {},
                goBackAfterCreate: false,
                formData: {
                    SampleSiteId: '',
                    CourseName: '',
                    AddSiteId: ''
                }
            };
        },
        computed: {
            fields() {
                return [
                    { key: "SampleSiteId", label: i18n.t('Tenant.Course.SampleSiteId.label'), input: { type: "select", objectName: "Tenant/Course/SiteId", idField: "SiteId", displayField: ["SiteId"] }, required: true },
                    { key: "CourseName", label: i18n.t('Tenant.Course.CourseName.label'), input: { type: "select", objectName: "Tenant/Course/CourseName", idField: "CourseName", displayField: ["CourseName"] }, required: true },
                    { key: "AddSiteId", label: i18n.t('Tenant.Course.AddSiteId.label'), input: { type: "selectmulti", objectName: "Tenant/Menu/SiteId", idField: "SiteId", displayField: ["SiteId"] }, required: true },
                ];
            },
            header() {
                return i18n.t('Tenant.Course.Header');
            }
        },
        watch: {
            'formData.SampleSiteId': async function (newSampleSiteId) {
                if (newSampleSiteId) {
                    const res = await this.getOptions("Tenant/Course/CourseName", { SampleSiteId: newSampleSiteId });
                    const result = res.Data.map(row => ({ value: row['CourseName'], text: row['CourseName'] }));
                    this.formData.CourseName = ''; // Clear the existing value before updating options
                    this.$refs.cmpCreate.formBind.CourseName = result;
                }
            }
        },
        methods: {
            getOptions(objectName, data) {
                const api = new ApiService(objectName);
                return api.getSelectOptions(objectName, data);
            }
        }
    };
</script>

